import { Button, Layout, Modal, Typography, useModal } from "matsuri-ui"
import { useCallback } from "react"
import { useTranslation } from "@/hooks/useTranslation"

interface PendingApprovalRequestWarningDialogProps {
    onClick: () => void
}

const PendingApprovalRequestWarningDialog = ({
    onClick,
    ...props
}: PendingApprovalRequestWarningDialogProps) => {
    const { t } = useTranslation()
    return (
        <Modal
            {...props}
            body={
                <Layout.Column gap={2}>
                    <Typography variant="h2">
                        {t("本日の承認リクエストが未確認です")}
                    </Typography>
                    <Typography>
                        {t(
                            "本日の承認リクエストで未確認のものがあります。至急確認してください。"
                        )}
                    </Typography>
                </Layout.Column>
            }
            footer={
                <Button
                    variant="filled"
                    color="primary"
                    onClick={onClick}
                    fullWidth
                >
                    {t("承認リクエストを確認")}
                </Button>
            }
        />
    )
}

export const usePendingApprovalRequestWarningDialog = ({
    onClick
}: PendingApprovalRequestWarningDialogProps) => {
    const [_openModal, closeModal] = useModal(
        PendingApprovalRequestWarningDialog,
        { size: "sm" }
    )

    const openModal = useCallback(() => {
        _openModal({
            onClick
        })
    }, [_openModal, onClick])

    return {
        openModal,
        closeModal
    }
}
